import { useBatchedListingPrices } from './useBatchedListingPrices';
import { AccommodationsConsoleState } from '@apps/accommodations/AccommodationsConsole.types';
import { useCombinedHotels } from './useCombinedHotels';
import { useAccommodationPlacesByCouple } from './useAccommodationPlacesByCouple';

interface UseAccommodationsConsoleListingsArgs {
  state: AccommodationsConsoleState;
  variant: 'couple' | 'regional';
}

export const useAccommodationsConsoleListings = (args: UseAccommodationsConsoleListingsArgs) => {
  const { state, variant } = args;
  const { accommodationPlaces } = useAccommodationPlacesByCouple();

  const { cachedListings, listings: listingsWithoutPricing, isFetchingListings } = useCombinedHotels(variant, args, accommodationPlaces);

  const { listings, isFetchingListingPrices, error } = useBatchedListingPrices({
    listingsWithoutPricing,
    state
  });

  return {
    /**
     * Can be used to retain maps points while loading new data
     */
    cachedListings,
    listings,
    isFetchingListings,
    isFetchingListingPrices,
    pricingError: error
  };
};
